module.exports = [{"path":"after-effects-project-files","name":"After Effects Project Files"},{"path":"apple-motion-templates","name":"Apple Motion"},{"path":"motion-graphics","name":"Motion Graphics"},{"path":"stock-footage","name":"Stock Footage"},{"path":"cinema-4d-templates","name":"Cinema 4D Templates"},{"path":"add-ons","name":"Add Ons"}]


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/videohive.json
// module id = 247
// module chunks = 1 2 3